import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {LinkSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/link'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

export const GenericCTAGroupSchema = buildEntrySchemaFor('genericCtaGroup', {
  fields: z.lazy(() =>
    z.object({
      primary: LinkSchema,
      secondary: safeOptional(LinkSchema),
      condition: z.string(),
    }),
  ),
})

export type GenericCTAGroup = z.infer<typeof GenericCTAGroupSchema>
